import React, {
    useState,
    useEffect,
} from 'react';
import { Link } from "react-router";
import { useQuery } from '@tanstack/react-query';

import { getCustomer } from "../router";

import * as CONSTANTS from "../constants";
import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import * as OPTIONS from "../option-fields";

import LoadingIndicator from '../components/loading-indicator';
import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import AvatarCircle from "../svg/avatar-circle";
import HeartCircle from "../svg/heart-circle";
import AccountIcons from "../svg/account-icons";
import UpsellBlock from '../components/upsell-block';
import TopPicks from '../components/top-picks';
import PreferencesBlock from './preferences-block';
import UpcomingTickets from './upcoming-tickets';
import CustomerMemberhips from './customer-memberships';
import { formatDate, sub } from 'date-fns';

const Account = () => {

    const { data: customer, customerPending, customerFetching } = getCustomer();

    //AGW - temporary removal of donation history block whilst we debug total donations issue and load performance of order history
    //const [totalDonations, setTotalDonations] = useState(null);
    const [customerTagIds, setCustomerTagIds] = useState(UTILS.getCustomerTagIds(customer?.tags));

   
    // const { 
    //     data: ordersDataAuth,
    // } = useQuery({
    //     queryKey: ['ordersDataAuth', customer.id],
    //     enabled: !!customer?.id,
    //     queryFn: () => QUERIES.getAuthenticatedOrders(customer.id), // if it is NOT a higher-order fn already
    //     // If getAuthenticatedOrders already returns a function, keep: queryFn: QUERIES.getAuthenticatedOrders(customer.id)
    //     refetchOnWindowFocus: false,
    //     retry: false,
    // });


    //AGW - temporary removal of donation history block whilst we debug total donations issue and load performance of order history 
    // useEffect(() => {
    //     if (!ordersDataAuth) return;

    //     const totalDonations = UTILS.getTotalDonations(ordersDataAuth);
    //     setTotalDonations(totalDonations);
    // }, [ordersDataAuth])

    useEffect(() => {
        if (!customer) return;

        setCustomerTagIds(UTILS.getCustomerTagIds(customer?.tags));
    }, [customer]);

    if (customerPending || customerFetching) return <LoadingIndicator type="page" />

    return (
        <>
            <AccountNavigation />
            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--overview'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'><AvatarCircle /> Hello, {customer.firstName}</h1>

                    {!customerTagIds?.length &&
                        <PreferencesBlock />
                    }

                    <div className='customer-status-blocks'>
                        <CustomerMemberhips />
            
                        {/* AGW - temporary removal of donation history block whilst we debug total donations issue and load performance of order history 
                        {totalDonations ?
                            <section className='customer-donation-history'>
                                <h2 className='booking-pathway__header'>
                                    <HeartCircle />
                                    Thank you, {customer.firstName}
                                </h2>
                                <div className='customer-donation-history__info'>
                                    <p>Through your support, you’ve donated… <span className='customer-donation-history__donation-amount'>£{totalDonations.toFixed(2)}</span></p>
                                    {OPTIONS.account.donation_history.introduction?.innerHTML &&                    
                                        <div dangerouslySetInnerHTML={{__html: OPTIONS.account.donation_history.introduction.innerHTML}}></div>
                                    }
                                </div>
                            </section>
                        :null} */}
                    </div>

                    <UpcomingTickets />

                    <section className='account-overview-navigation'>
                        <h2 className='booking-pathway__header'>Your account</h2>
                        <ul className='account-overview-navigation__list' role="list">
                            {CONSTANTS.ACCOUNT_AREAS.map(area => {
                                if (area.icon) return (
                                    <li key={area.link}>
                                        <Link to={area.link} className='account-overview-navigation__list--link'>
                                            <AccountIcons icon={area.icon} />
                                            <span>
                                                <span className='account-overview-navigation__list--header'>{area.title}</span>
                                                <span>{area.description}</span>
                                            </span>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </section>

                    <TopPicks origin="account" customer={customer} />

                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    {customer.subscriptions?.length ?
                        <UpsellBlock content={OPTIONS.account.thank_you} type="overview-thank-you" />
                    :
                        <UpsellBlock content={OPTIONS.account.overview_upsell} type="overview-upsell" />
                    }
                </div>

            </div>
        </>
    );
};

export default Account;